import styled from 'styled-components';
import { colors } from '../../utils/colors';

export const Partner = styled.div`
  border-top: 1px solid ${colors.secondaryOne}80;
`;

export const IconPartner = styled.div`
  width: 100%;
  display: flex;
  align-items: start;
  margin-top: 25px;
  margin-bottom: 25px;

  div {
    width: 150px;
    height: 120px;
    background-image: url(${({ img }) => img});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Link = styled.div`
  font-size: 18px;
  margin: 0 0 50px;
  text-align: left;

  a {
    color: ${colors.primaryOne};
    text-decoration: underline !important;
  }
`;
